export class ApproveRejectNotification {
    email: string;
    notifyApproved: boolean;
    notifyRejected: boolean;
}